module.exports = __webpack_public_path__ + "img/tips.c66805ee.png";